var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { createContext, useContext, useEffect, useState } from "react";
import { StartupError } from "../components/StartupError";
import { Loader } from "@sequentech/ui-essentials";
var defaultSettingsValues = {
    loaded: false,
    globalSettings: {
        DISABLE_AUTH: false,
        QUERY_POLL_INTERVAL_MS: 2000,
        DEFAULT_TENANT_ID: "90505c8a-23a9-4cdf-a26b-4e19f6a097d5",
        DEFAULT_EVENT_ID: "33f18502-a67c-4853-8333-a58630663559",
        ONLINE_VOTING_CLIENT_ID: "voting-portal",
        KEYCLOAK_URL: "http://localhost:8090/",
        HASURA_URL: "http://localhost:8080/v1/graphql",
        APP_VERSION: "-",
        APP_HASH: "-",
        BALLOT_VERIFIER_URL: "http://127.0.0.1:3001/",
        RESULTS_PORTAL_URL: "http://127.0.0.1:3004",
        PUBLIC_BUCKET_URL: "http://localhost:9002/public/",
        KEYCLOAK_ACCESS_TOKEN_LIFESPAN_SECS: 900,
        POLLING_DURATION_TIMEOUT: 12000,
    },
    defaultLanguageTouched: false,
    setDefaultLanguageTouched: function () { },
    setDisableAuth: function () { },
};
export var SettingsContext = createContext(defaultSettingsValues);
var SettingsContextProvider = function (props) {
    var _a = useState(false), failed = _a[0], setFailed = _a[1];
    var _b = useState(false), loaded = _b[0], setLoaded = _b[1];
    var _c = useState(false), defaultLanguageTouched = _c[0], setDefaultLanguageTouched = _c[1];
    var _d = useState(defaultSettingsValues.globalSettings), globalSettings = _d[0], setSettings = _d[1];
    var isPreviewMatch = window.location.pathname.includes("preview/") &&
        !window.location.pathname.includes("tenant/");
    useEffect(function () {
        if (!loaded) {
            loadSettings();
        }
    }, [loaded]);
    var loadSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var value, json, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("/global-settings.json")];
                case 1:
                    value = _a.sent();
                    if (!value.ok)
                        throw new Error("Settings request failed");
                    return [4 /*yield*/, value.json()];
                case 2:
                    json = (_a.sent());
                    if (isPreviewMatch) {
                        json.DISABLE_AUTH = true;
                    }
                    setSettings(json);
                    setLoaded(true);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setFailed(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var setDisableAuth = function (disable) {
        setSettings(__assign(__assign({}, globalSettings), { DISABLE_AUTH: disable }));
    };
    // Setup the context provider
    return (_jsx(SettingsContext.Provider, { value: {
            loaded: loaded,
            failed: failed,
            globalSettings: globalSettings,
            setDisableAuth: setDisableAuth,
            defaultLanguageTouched: defaultLanguageTouched,
            setDefaultLanguageTouched: setDefaultLanguageTouched,
        }, children: props.children }));
};
export var SettingsGate = function (_a) {
    var children = _a.children;
    var _b = useContext(SettingsContext), loaded = _b.loaded, failed = _b.failed;
    if (failed)
        return _jsx(StartupError, {});
    return loaded ? _jsx(_Fragment, { children: children }) : _jsx(Loader, {});
};
export var SettingsWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(SettingsContextProvider, { children: _jsx(SettingsGate, { children: children }) }));
};
